import { useTranslation } from 'react-i18next';

import { getMonth, TDurationType } from '@/utils/tools/DateTools';
import { zeroPad } from '@/utils/tools/MathTools';
import { DashboardUserStatus } from '@/features/dashboard-users/components/DashboardUserStatus/DashboardUserStatus';
import { ISupportUser } from '@/features/dashboard-users/store/support-user.model';

interface IGeneralInformationProps {
  isBlocked: boolean;
  dashboardUser: ISupportUser;
  lastLogin?: {
    value: number;
    unit: string;
    type: TDurationType;
  };
  creationDate: Date;
  accessExpirationDate?: Date;
  shouldShowExpirationDate?: boolean;
}

export function GeneralInformation({
  isBlocked,
  dashboardUser,
  lastLogin,
  creationDate,
  accessExpirationDate,
  shouldShowExpirationDate = false,
}: IGeneralInformationProps) {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-5">
      <div className="flex flex-col gap-4">
        <p className="typo-subtitle-subtitle2 text-tertiary uppercase">
          {t('pages.administration.supportsUsers.details.account.generalInformation')}
        </p>

        <div className="grid grid-cols-[auto_1fr] gap-y-3 gap-x-5 items-center ">
          <span className="typo-body-regular-paragraph text-secondary">
            {t('pages.administration.supportsUsers.details.account.userName')}
          </span>
          <span className="typo-body-regular-paragraph text-secondary break-all">{dashboardUser.username}</span>

          <span className="typo-body-regular-paragraph text-secondary">
            {t('pages.administration.supportsUsers.details.account.status')}
          </span>
          <DashboardUserStatus isBlocked={isBlocked} dashboardUser={dashboardUser} userId={dashboardUser.id} />

          <span className="typo-body-regular-paragraph text-secondary">
            {t('pages.administration.supportsUsers.details.account.lastActive')}
          </span>
          <span className="typo-body-regular-paragraph text-secondary">
            {!!lastLogin ? `${lastLogin.value} ${lastLogin.unit} ago` : '-'}
          </span>

          <span className="typo-body-regular-paragraph text-secondary">
            {t('pages.administration.supportsUsers.details.account.createdOn')}
          </span>
          <span className="typo-body-regular-paragraph text-secondary">{`${t(getMonth(creationDate.getMonth())).slice(0, 3)} ${zeroPad(creationDate.getDate(), 2)}, ${creationDate.getFullYear()}`}</span>

          {!!shouldShowExpirationDate && (
            <>
              <span className="typo-body-regular-paragraph text-secondary">
                {t('pages.administration.supportsUsers.details.account.expiresOn')}
              </span>
              <span className="typo-body-regular-paragraph text-secondary">
                {accessExpirationDate
                  ? `${t(getMonth(accessExpirationDate.getMonth())).slice(0, 3)} ${zeroPad(accessExpirationDate.getDate(), 2)}, ${accessExpirationDate.getFullYear()}`
                  : '-'}
              </span>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
